import { SourceLogsBundle } from '@/parsing/SourceLogsBundle';
import { SerializedLog } from '@/workers/serialization/SerializedLog';
import { WorkerClient, WorkerClientFactory, WorkerClientInput } from '@/workers/WorkerClient';

import {
  CombinedLogParserWorkerArgs,
  CombinedLogParserWorkerResult,
} from './CombinedLogParserWorkerServer';

export class CombinedLogParserWorkerClient {
  private client: WorkerClient;

  constructor() {
    const worker = new Worker(new URL('./CombinedLogParserWorkerServer.ts', import.meta.url));
    this.client = WorkerClientFactory.make(worker);
  }

  async parse(
    bundle: SourceLogsBundle,
    onProgress: (progress: number) => void,
  ): Promise<SerializedLog> {
    // eslint-disable-next-line no-async-promise-executor -- TODO: fix linter issue
    return new Promise(async (fulfill, reject) => {
      try {
        const args: CombinedLogParserWorkerArgs = {
          bundle,
        };
        const input: WorkerClientInput = {
          name: 'parseLog',
          args,
          onProgress,
        };
        const ctx = this.client.execute(input);

        const result: CombinedLogParserWorkerResult = await ctx.promise;
        fulfill(result.serializedLog);
      } catch (error) {
        reject(error);
      }
    });
  }

  shutdown() {
    this.client.shutdown();
  }
}
